/** Frame time and draw calls, for the dev overlay. Written by main.ts, read by the HUD. */
import { createStore } from './store';

export interface Stats {
  fps: number;
  frameMs: number;
  calls: number;
  triangles: number;
  /** The quality tier the world draws at, or its look when it has none. */
  quality: string;
}

export const stats = createStore<Stats>({
  fps: 0,
  frameMs: 0,
  calls: 0,
  triangles: 0,
  quality: '',
});
